import React, { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Container,
  TopInfoWrapper,

} from '../members/styles'
import { Button, ModalVariables, Table, TopProgress } from '../../../../../components'
import { icons } from '../../../../../icons'
import { useNavigate, useParams } from 'react-router-dom'
import { loadBalancerService } from '../../../../../api'
import { useUi } from '../../../../../context/ui.context'
import { handleStatusName } from '../../../../../utils/handle-status-name'
import { StateWrapper, GreenDot, Greentext } from '../../../Instances/styles'

const Listeners:FC = () => {
  const [t] = useTranslation()
  const {poolId, lbId} = useParams()
  const {viewAlert} = useUi()
  const navigate = useNavigate()
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const [loading, setLoading] = useState<boolean>(false)
  const [listeners, setListeners] = useState<any[]>([])
  const [viewModal, setViewModal] = useState<boolean>(false)
  const [activeAnimation, setActiveAnimation] = useState<boolean>(false)
  const [modalType, setModalType] = useState<any>('')
  const [alertTitle, setAlertTitle] = useState<any>()
  const [alertSubTitle, setAlertSubTitle] = useState<any>()
  const [deletedMonitor, setDeletedMonitor] = useState<any>()

  const _updateMonitors = () => {
    //@ts-ignore
    loadBalancerService.getPoolHealthMonitors(poolId)
    .then((res) => {
      setListeners(res.data.objects.map((monitor:any) => {
        return{
          ...monitor,
          name:monitor.name || 'n/a',
          admin_state_up:monitor.admin_state_up ? 'Yes' : 'No',
          navigate: `/openstack/load-balancer-pool/${lbId}/${poolId}/health-monitors/${monitor.id}`,
          operating_status: 
            (<StateWrapper>
              <GreenDot active={monitor.operating_status}/>
              <Greentext active={monitor.operating_status}>
                {handleStatusName(monitor.operating_status, t)}
              </Greentext>
            </StateWrapper>),
          provisioning_status: 
            (<StateWrapper>
              <GreenDot active={monitor.provisioning_status}/>
              <Greentext active={monitor.provisioning_status}>
                {handleStatusName(monitor.provisioning_status, t)}
              </Greentext>
            </StateWrapper>),
        }
      }))
      setPageLoading(false)
      setLoading(false)
    })
  }
  const _deleteMonitor = async () => {
    if(!poolId) return
    setLoading(true)
    try{
      await loadBalancerService.deleteHealthMonitor(poolId, deletedMonitor.id)
      await viewAlert({
        severity:'info',
        message:`${t("HEALTH_MONITOR_DELETED_SUCCESSFULLY")}`
      })
      await _updateMonitors()
    } catch (e:any) {
      viewAlert({
        severity:'error',
        message:e?.response?.data?.detail ||`${t("ERROR_OCCURRED")}`,
      })
      _updateMonitors()
      setPageLoading(false)
      setLoading(false)
    } finally {
      setViewModal(false)
      setActiveAnimation(false)
    }
  }
  useEffect(() => {
    _updateMonitors()
    const interval = setInterval(() => {
      _updateMonitors()
    },10000)
    return () => clearInterval(interval)
  },[])
  const openModal = (modal:any) => {
    setModalType(modal)
    setViewModal(true)
    setActiveAnimation(true)
  }
  const closeModal = (props:any) => {
    _deleteMonitor()
  }
  const closeModalCancel = () => {
    setViewModal(false)
    setActiveAnimation(false)
  }
  const items = [
    {
      title:t("EDIT"),
      id:'2',
      icon:icons.Edit,
      onClick: (monitor:any) => navigate(`${monitor.id}/edit`),
      divider:false
    },
    {
      title:t("DELETE"),
      id:'4',
      onClick:(id:any) => {
        openModal('delete')
        setAlertTitle(t("HEALTH_MONITOR"))
        setAlertSubTitle([id])
        setDeletedMonitor(id)
      },
      icon:icons.DeleteIcon,
      divider:false
    },
  ]
  const Columns = [
    {
      title:t("NAME"),
      key:'name'
    },
    {
      title:t("PROTOCOL"),
      key:'type',
    },
    {
      title:t("OPERATING_STATUS"),
      key:'operating_status'
    },
    {
      title:t("PROVISIONING_STATUS"),
      key:'provisioning_status'
    },
    {
      title:t("ADMIN_STATE_UP"),
      key:'admin_state_up'
    },
    {
      title:'',
      key:'props'
    },
  ]
  if(pageLoading) return <TopProgress loading={pageLoading}/>
  return(
    <Container>
      <TopProgress loading={loading}/>
      <TopInfoWrapper>
        <div style={{display:'flex', marginBottom:'20px'}}>
          <Button
            variant="primary"
            size="display"
            onClick={() => navigate(`create`)}
            title={t("CREATE_NEW_MONITOR")}
            customStyles={{marginRight:'10px'}}
          />
        </div>
      </TopInfoWrapper>
        <Table
          columns={Columns}
          rows={listeners}
          settings={items}
          hideOther
          hideCheckbox
        />
      <ModalVariables
        modalType={modalType}
        viewModal={viewModal}
        activeAnimation={activeAnimation}
        closeModal={closeModal}
        closeModalCancel={closeModalCancel}
        alertTitle={alertTitle}
        alertSubTitle={alertSubTitle}
        // dataToEdit={editedSubnet}
        loading={loading}
      />
    </Container>
  )
}
export default Listeners
